import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Planner from "@/pages/Planner";
import Sip from "@/pages/tools/Sip";
import Lumpsum from "@/pages/tools/Lumpsum";
import GoalPlanner from "@/pages/tools/GoalPlanner";
import Ppf from "@/pages/tools/Ppf";
import Nps from "@/pages/tools/Nps";
import Fd from "@/pages/tools/Fd";
import HomeLoan from "@/pages/tools/HomeLoan";
import RentalYield from "@/pages/tools/RentalYield";
import BuyVsRent from "@/pages/tools/BuyVsRent";
import TermInsurance from "@/pages/tools/TermInsurance";
import HealthInsurance from "@/pages/tools/HealthInsurance";
import IncomeTax from "@/pages/tools/IncomeTax";
import EmergencyFund from "@/pages/tools/EmergencyFund";
import EducationPlanner from "@/pages/tools/EducationPlanner";
import CapitalGains from "@/pages/tools/CapitalGains";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/retirement" element={<Planner />} />
          <Route path="/sip" element={<Sip />} />
          <Route path="/lumpsum" element={<Lumpsum />} />
          <Route path="/goal" element={<GoalPlanner />} />
          <Route path="/ppf" element={<Ppf />} />
          <Route path="/nps" element={<Nps />} />
          <Route path="/fd" element={<Fd />} />
          <Route path="/home-loan" element={<HomeLoan />} />
          <Route path="/rental-yield" element={<RentalYield />} />
          <Route path="/buy-vs-rent" element={<BuyVsRent />} />
          <Route path="/term-insurance" element={<TermInsurance />} />
          <Route path="/health-insurance" element={<HealthInsurance />} />
          <Route path="/income-tax" element={<IncomeTax />} />
          <Route path="/emergency-fund" element={<EmergencyFund />} />
          <Route path="/education" element={<EducationPlanner />} />
          <Route path="/capital-gains" element={<CapitalGains />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
